import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

import { defaultAvatarUrl } from '@/config/constants';

import useMeQuery from '@/api/queries/me/useMeQuery';

export const useAvatarStore = defineStore('avatar', () => {
  const { auth } = useMeQuery();

  const isAvatarLoading = ref(false);

  const isDefaultAvatar = computed(() => auth.value?.branding?.avatar === defaultAvatarUrl);

  // The user uploaded a picture of their own (default avatar / no avatar excluded)
  const hasAvatar = computed(() => !!auth.value?.branding?.avatar && !isDefaultAvatar.value);

  return {
    isAvatarLoading,
    isDefaultAvatar,
    hasAvatar,
  };
});
